import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UseCase } from '@digibricks/core';
export var DELETE_FILE_USE_CASE = 'DELETE_FILE_USE_CASE';
export var DeleteFileUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(DeleteFileUseCase, _UseCase);

  var _super = _createSuper(DeleteFileUseCase);

  function DeleteFileUseCase(fileStorageRepository) {
    var _this;

    _classCallCheck(this, DeleteFileUseCase);

    _this = _super.call(this);
    _this.fileStorageRepository = fileStorageRepository;
    return _this;
  }

  _createClass(DeleteFileUseCase, [{
    key: "validate",
    value: function validate(input) {
      var id = input.id;
      var guardCollections = [{
        argument: id,
        argumentName: 'ID'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var resultOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultOrError = this.validate(input);

                if (!resultOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 3:
                _context.next = 5;
                return this.fileStorageRepository["delete"](input);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return DeleteFileUseCase;
}(UseCase);